import type { Application } from "../api";
import { formatDate } from "../presentation";
import { ManagementHeading } from "./ManagementCommon";
import { Button } from "./ui/Button";
import { CopyField } from "./ui/CopyField";
import { Icon } from "./ui/Icon";

/** 应用级凭证页面。AppSecret 永不从查询接口回显，轮换仍只展示一次。 */
export function CredentialsSecurityView({ application, applications, onSelect, busy, onRotate }: {
  readonly application: Application;
  readonly applications: readonly Application[];
  readonly onSelect: (application: Application) => void;
  readonly busy: boolean;
  readonly onRotate: () => void;
}) {
  const native = application.appType === "native";
  return <div className="management-page credentials-page">
    <ManagementHeading title="凭证与安全" description={native ? "管理 AppKey、管理员身份和 UserSig 签发边界。" : "查看 OIDC Public Client 身份和浏览器安全边界。"} applications={applications} selected={application} onSelect={onSelect} />
    <div className="credentials-layout">
      <section className="surface-card credential-primary-card">
        <header><span><Icon name="key" /></span><div><h3>{native ? "原生应用凭证" : "Web 应用身份"}</h3><p>{native ? "AppSecret 仅供业务服务端保存" : "Public Client 不签发客户端密钥"}</p></div></header>
        <div className="copy-field-grid"><CopyField label="AppKey" value={application.appKey} /><CopyField label="Tenant ID" value={application.tenantId} /></div>
        {native ? <dl className="configuration-list credential-metadata"><div><dt>管理员 userID</dt><dd>{application.adminUserId}</dd></div><div><dt>UserSig 有效期</dt><dd>{application.userSigExpireSeconds.toLocaleString("zh-CN")} 秒</dd></div><div><dt>密钥版本</dt><dd>v{application.credential.version}</dd></div><div><dt>密钥创建时间</dt><dd>{application.credential.createdAt === null ? "暂无记录" : formatDate(application.credential.createdAt)}</dd></div></dl> : <div className="credential-public-note"><Icon name="check" /><div><strong>无需 AppSecret</strong><p>浏览器使用 Authorization Code + PKCE；Token 和服务端密钥不会写入页面构建产物。</p></div></div>}
      </section>
      <aside className="surface-card security-principles">
        <h3>安全边界</h3>
        <ul><li>客户端不得保存 AppSecret</li><li>UserSig 必须由业务服务端签发</li><li>管理员 UserSig 不得下发给客户端</li><li>密钥、Token 和消息正文不得进入日志</li></ul>
      </aside>
    </div>
    {native ? <section className="surface-card danger-zone"><div><span><Icon name="warning" /></span><div><h3>轮换 AppSecret</h3><p>轮换会使旧 AppSecret 签发的 UserSig 立即失效。请先准备业务服务端更新和客户端重新登录方案。</p></div></div><Button loading={busy} variant="danger" onClick={onRotate}>轮换密钥</Button></section> : null}
  </div>;
}
